// extracted by mini-css-extract-plugin
export var bar = "AlertBar-module--bar--929b7";
export var body = "AlertBar-module--body--df153";
export var close = "AlertBar-module--close--d6f3d";
export var cta = "AlertBar-module--cta--8b6f1";
export var heading = "AlertBar-module--heading--a093b";
export var inner = "AlertBar-module--inner--56d6b";